import { COLORS, FONT } from '../../../../constants';
export var StyleOverrides = {
  '.navBar': {
    display: 'flex'
  },
  '.DayPicker-Month': {
    margin: 0,
    width: '100%',
    '.DayPicker-Caption': {
      textAlign: 'center',
      color: COLORS.grays.darkest,
      fontFamily: 'Lato',
      fontSize: 16,
      fontWeight: 'bold',
      letterSpacing: 0,
      lineHeight: '24px'
    }
  },
  '.DayPicker-wrapper': {
    paddingBottom: 0,
    outline: 'none'
  },
  '&.calendar-arrow': {
    position: 'absolute',
    '&.previous, &.next': {
      outline: 'none',
      userSelect: 'none',
      border: 0,
      boxShadow: 'none',
      padding: '4px 0',
      '&:focus > svg': {
        fill: COLORS.grays.darkest
      },
      '> svg': {
        fill: COLORS.grays.darkest,
        minWidth: 16,
        minHeight: 16
      }
    },
    '&.next': {
      right: 0,
      '> svg': {
        transform: 'rotate(180deg)',
        transformOrigin: '50% 50%'
      }
    }
  },
  svg: {
    '&.range-arrow': {
      minWidth: 16,
      minHeight: 16,
      margin: '0 6px',
      fill: COLORS.grays.light
    },
    '&.trustpilot-icon.daterange-dropdown-icon': {
      marginLeft: 8,
      width: 14,
      height: 14
    }
  },
  '.Range': {
    input: {
      outline: 'none'
    },
    '.DayPicker-Weekday': {
      fontFamily: 'Lato',
      fontSize: 12,
      fontWeight: 'normal',
      letterSpacing: 0,
      lineHeight: '16px',
      textAlign: 'center',
      abbr: {
        color: COLORS.grays.gray
      }
    },
    '&.DayPicker:not(.DayPicker--interactionDisabled)': {
      '.DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover': {
        backgroundColor: 'rgba(54, 140, 215, 0.15)'
      }
    },
    '.DayPicker-Day': {
      borderRadius: 0,
      border: "1px solid " + COLORS.grays.cardBorder,
      outline: 'none',
      fontFamily: FONT.family,
      fontWeight: FONT.weight.regular,
      fontSize: FONT.sizes.regular.fontSize,
      letterSpacing: 0,
      lineHeight: '20px',
      textAlign: 'center',
      color: COLORS.grays.darkest,
      '&.DayPicker-Day--outside': {
        color: COLORS.grays.light,
        cursor: 'pointer'
      },
      '&.DayPicker-Day--future': {
        color: COLORS.grays.lightest,
        cursor: 'default',
        pointerEvents: 'none'
      }
    },
    '.DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end)': {
      background: 'rgba(54, 140, 215, 0.15)',
      color: COLORS.grays.darkest,
      '&.DayPicker-Day--outside': {
        color: COLORS.grays.light
      }
    },
    '.DayPicker-Day--selected': {
      '&.DayPicker-Day--start': {
        background: COLORS.blues.primary,
        color: COLORS.white,
        borderRadius: '6px 0px 0px 4px'
      },
      '&.DayPicker-Day--end': {
        background: COLORS.blues.primary,
        color: COLORS.white,
        borderRadius: '0px 4px 3px 0px',
        '&.DayPicker-Day--single': {
          borderRadius: '6px 4px 3px 4px'
        }
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/daterange/StyleOverrides.js
// module id = 1035
// module chunks = 0